import React, { memo } from 'react';
export function ProblemSection() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-164">
      <div className="max-w-3xl mx-auto" data-id="element-165">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-center text-black mb-10 leading-tight" data-id="element-166">
          The problem <span className="italic text-soft-gold" data-id="element-167">no one</span> says
          out loud
        </h2>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg border border-orange/20" data-id="element-168">
          <p className="font-sans text-xl text-gray-800 mb-8 font-medium" data-id="element-169">
            If you're a dog owner, this probably feels familiar:
          </p>

          <ul className="space-y-5 mb-10" data-id="element-170">
            {['You take lots of photos, but very few feel truly special', 'Your dog moves before you get the shot', 'You never know what angle looks best', 'Indoor photos come out dark or flat', 'Outdoor photos feel random or messy', 'You want beautiful memories, but your results feel inconsistent'].map((item, index) => <li key={index} className="flex items-start" data-id="element-171">
                <span className="text-red-500 mr-4 text-xl mt-0.5" data-id="element-172">❌</span>
                <span className="font-sans text-lg text-gray-700" data-id="element-173">{item}</span>
              </li>)}
          </ul>

          <div className="bg-red-50 p-6 rounded-xl border border-red-100" data-id="element-174">
            <p className="font-sans text-lg text-gray-800" data-id="element-175">
              And the worst part is this constant feeling of:
            </p>
            <p className="font-serif text-xl md:text-2xl font-bold text-black mt-3 italic" data-id="element-176">
              "I know my dog is adorable… I just wish I knew how to capture it
              better."
            </p>
          </div>
        </div>
      </div>
    </section>;
}